import { InventoryCategoryType } from "@/modules/warehouses/inventory-categories/types"
import { Http } from "@/network/http"
import { notificationAction } from "@/utils"
import { Filters, NotificationEnum, StatusEnum } from "@/utils/constants"

export const API_PREFIX_PATH = "/inventory-categories"

export const fetchInventoryCategories = async (filters?: Filters) => {
  return await Http.get(`${API_PREFIX_PATH}`, { params: filters })
}

export const createInventoryCategory = async (data: any) => {
  return await Http.post(`${API_PREFIX_PATH}`, data)
}
export const fetchInventoryCategory = async (id: string) => {
  return await Http.get(`${API_PREFIX_PATH}/${id}`)
}
export const updateInventoryCategory = async (id: string, data: any) => {
  return await Http.put(`${API_PREFIX_PATH}/${id}`, data)
}
export const deleteInventoryCategory = async (data: InventoryCategoryType) => {
  try {
    const updatedData = { ...data }
    if (!updatedData.id) return
    const response = await updateInventoryCategory(updatedData.id, { ...updatedData, status: StatusEnum.DELETED })
    if (response.statusCode === 200) {
      notificationAction(NotificationEnum.DELETED, NotificationEnum.SUCCESS)
    }
  } catch (error) {
    console.error("Addition failed:", error)
    notificationAction(`Lỗi ${error}`, NotificationEnum.ERROR)
  }
}